module.exports = __webpack_public_path__ + "img/no2_label.ea21139e.svg";